const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  // TODO routes for weddings & rentals
  // {
  //   path: ["/test"],
  //   exact: true,
  //   component: "Home",
  // },
];

export default routes;
